import React from 'react'

import Image from 'next/image'

import { Row, Text } from 'Components/UI'

import { Container } from './styles'

import { Technology } from '../types'

type Props = {
  data?: Technology[]
}

function TechnologiesRow({ data }: Props) {
  if (!data?.length) return null

  return (
    <Row gap={4} wrap>
      {data.map(item => (
        <Container key={item.id}>
          <Image alt={`Logo of ${item.title}`} src={item.logo} />

          <Text as="h4" body20 medium title>
            {item.title}
          </Text>
        </Container>
      ))}
    </Row>
  )
}

export default TechnologiesRow
